import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import PersistHydrationSync from "./components/PersistHydrationSync";

import { store } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";
import { persistStore } from "reduxjs-toolkit-persist";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ToastContainer } from "react-toastify";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ToastContainer />
        <PersistHydrationSync />
        <App />
      </LocalizationProvider>
    </PersistGate>
  </Provider>
);
